// extracted by mini-css-extract-plugin
module.exports = {"Box":"styles_Box__5JlK2","Vertical":"styles_Vertical__1VlPG"};